// 全局响应式管理器
import { createResponsiveListener } from './responsive.js'

class ResponsiveManager {
  constructor() {
    this.listeners = []
    this.currentBreakpoint = this.getBreakpoint()
    this.isMobile = window.innerWidth <= 768
    this.isTablet = window.innerWidth > 768 && window.innerWidth <= 1024
    this.isDesktop = window.innerWidth > 1024
    
    // 创建全局监听器
    this.cleanup = createResponsiveListener((data) => {
      this.updateBreakpoint(data)
    })
  }

  // 获取当前断点
  getBreakpoint() {
    const width = window.innerWidth
    if (width <= 480) return 'xs'
    if (width <= 768) return 'sm'
    if (width <= 992) return 'md'
    if (width <= 1200) return 'lg'
    return 'xl'
  }

  // 更新断点信息
  updateBreakpoint(data) {
    const oldBreakpoint = this.currentBreakpoint
    const oldIsMobile = this.isMobile
    const oldIsTablet = this.isTablet
    const oldIsDesktop = this.isDesktop

    this.currentBreakpoint = data.screenSize
    this.isMobile = data.isMobile
    this.isTablet = data.isTablet
    this.isDesktop = data.isDesktop

    // 通知所有监听器
    this.notifyListeners({
      ...data,
      oldBreakpoint,
      oldIsMobile,
      oldIsTablet,
      oldIsDesktop
    })
  }

  // 添加监听器
  addListener(callback) {
    this.listeners.push(callback)
    // 立即调用一次，提供当前状态
    callback({
      width: window.innerWidth,
      height: window.innerHeight,
      screenSize: this.currentBreakpoint,
      isMobile: this.isMobile,
      isTablet: this.isTablet,
      isDesktop: this.isDesktop
    })
  }

  // 移除监听器
  removeListener(callback) {
    const index = this.listeners.indexOf(callback)
    if (index > -1) {
      this.listeners.splice(index, 1)
    }
  }

  // 通知所有监听器
  notifyListeners(data) {
    this.listeners.forEach(callback => {
      try {
        callback(data)
      } catch (error) {
        console.error('响应式监听器错误:', error)
      }
    })
  }

  // 获取当前状态
  getCurrentState() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      screenSize: this.currentBreakpoint,
      isMobile: this.isMobile,
      isTablet: this.isTablet,
      isDesktop: this.isDesktop
    }
  }

  // 销毁管理器
  destroy() {
    if (this.cleanup) {
      this.cleanup()
    }
    this.listeners = []
  }
}

// 创建全局实例
const responsiveManager = new ResponsiveManager()

// Vue插件
export const ResponsivePlugin = {
  install(Vue) {
    // 添加全局属性
    Vue.prototype.$responsive = responsiveManager

    // 添加全局混入
    Vue.mixin({
      data() {
        return {
          responsiveState: responsiveManager.getCurrentState()
        }
      },
      mounted() {
        // 添加监听器
        this.responsiveCallback = (data) => {
          this.responsiveState = data
        }
        responsiveManager.addListener(this.responsiveCallback)
      },
      beforeDestroy() {
        // 移除监听器
        if (this.responsiveCallback) {
          responsiveManager.removeListener(this.responsiveCallback)
        }
      }
    })
  }
}

export default responsiveManager 